import { render, staticRenderFns } from "./IconTextRight.vue?vue&type=template&id=0d7665ce&"
import script from "./IconTextRight.vue?vue&type=script&lang=js&"
export * from "./IconTextRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d7665ce')) {
      api.createRecord('0d7665ce', component.options)
    } else {
      api.reload('0d7665ce', component.options)
    }
    module.hot.accept("./IconTextRight.vue?vue&type=template&id=0d7665ce&", function () {
      api.rerender('0d7665ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconTextRight.vue"
export default component.exports